import styled, { ThemeProvider } from 'styled-components';
import theme from '../../../styles/theme'

import type { GetVictimType } from '../../../types/GetVictim'

const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.regular};
    font-weight: ${props => props.theme.font.weight.regular};

    @media print {
        page-break-inside: avoid;
    }
`;

const HeaderRow = styled.tr`
    background-color: Black;
    color: White;
    font-family: ${props => props.theme.font.family};
    font-size: ${props => props.theme.font.size.regular};
    font-weight: ${props => props.theme.font.weight.bold};

    @media print {
        background-color: Black !important;
        color: White !important;
    }
`;

const TableCell = styled.td`
    border: 1px solid black;
    padding 8px;
    white-space: nowrap;
`;

const Label = styled.div`
    font-size: ${props => props.theme.font.size.small};
    font-weight: ${props => props.theme.font.weight.bold};
`;

interface VictimsProps {
    victims: GetVictimType[];
}

const Victims: React.FC<VictimsProps> = ({ victims }) => {

    return (
        <ThemeProvider theme={theme} >
            {
                victims.map((victim, index) => (
                    <Table key={index} cellPadding="0" cellSpacing="0">
                        <tbody>
                            <HeaderRow>
                                <td>VICTIM : {victim.name}</td>
                            </HeaderRow>
                            <tr>
                                <td>
                                    <Table key={index} cellPadding="2" cellSpacing="0">
                                        <tbody>
                                            <tr>
                                                <TableCell>
                                                    <Label>Involvement</Label>
                                                    {victim && victim.involvement ? victim.involvement : '\u00A0'}
                                                </TableCell>
                                                <TableCell>
                                                    <Label>Invl No</Label>
                                                    {victim && victim.invlNo ? victim.invlNo.replace(/"/g, '') : '\u00A0'}
                                                </TableCell>
                                                <TableCell>
                                                    <Label>Name</Label>
                                                    {victim && victim.name ? victim.name : '\u00A0'}
                                                </TableCell>
                                                <TableCell>
                                                    <Label>Sex</Label>
                                                    {victim && victim.sex ? victim.sex : '\u00A0'}
                                                </TableCell>
                                                <TableCell>
                                                    <Label>Race</Label>
                                                    {victim && victim.race ? victim.race : '\u00A0'}
                                                </TableCell>
                                                <TableCell width="100%">
                                                    &nbsp;
                                                </TableCell>
                                            </tr>
                                        </tbody>
                                    </Table>
                                </td>
                            </tr>
                        </tbody>
                    </Table>

                ))
            }
        </ThemeProvider>
    );
}

export default Victims;